// extracted by mini-css-extract-plugin
export default {"headerCell":"headerCell---mcXOS","emptyHeaderCell":"emptyHeaderCell---MzfjE"};